import { render, staticRenderFns } from "./ShipmentBulkExportModal.vue?vue&type=template&id=910b5630&scoped=true&"
import script from "./ShipmentBulkExportModal.vue?vue&type=script&lang=js&"
export * from "./ShipmentBulkExportModal.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentBulkExportModal.vue?vue&type=style&index=0&id=910b5630&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "910b5630",
  null
  
)

export default component.exports